var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { map } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { FindVariableForDesignerDto } from '../../../../../shared/service-proxies/service-proxies';
import { VariableVersion } from '../variable-version';
import { CONFIGURE_PROJECT_INFO } from '../../project/configure-project-info';
import * as _ from 'lodash';
var RemoteVariableService = /** @class */ (function () {
    function RemoteVariableService(variableService, projectInfo) {
        this.variableService = variableService;
        this.projectInfo = projectInfo;
    }
    RemoteVariableService.prototype.findVariable = function (variableId) {
        if (variableId === undefined) {
            throw new Error('variableId can not be undefined.');
        }
        var input = new FindVariableForDesignerDto();
        input.configureId = this.projectInfo.id;
        input.configureVariableName = variableId.name;
        return this.variableService.findVariableForDesigner(input).pipe(map(function (value) {
            if (!value) {
                return undefined;
            }
            var unit = value.unit ? value.unit : undefined;
            return {
                id: variableId,
                dataType: value.dataType.valueOf(),
                charCount: value.charCount,
                unit: unit,
                lowerLimit: value.minValue,
                upperLimit: value.maxValue,
            };
        }));
    };
    RemoteVariableService.prototype.getVariablesName = function (dataType, readWriteModel) {
        return this.variableService.getVariablesForDesigner(this.projectInfo.id, dataType, readWriteModel)
            .pipe(map(function (t) {
            return _.map(t, function (item) {
                return ({
                    name: item.variableName,
                    groupName: item.groupName
                });
            });
        }));
    };
    RemoteVariableService.prototype.getVariables = function (searchingVariableName, selectedVariableName, selectedDataSourceId, selectedGroupNameId, dataType, readWriteModel, sorting, maxResultCount, skipCount) {
        return this.variableService.getVariablesForDesignerSelect(this.projectInfo.id, searchingVariableName, selectedVariableName, selectedDataSourceId, selectedGroupNameId, dataType, readWriteModel, sorting, maxResultCount, skipCount)
            .pipe(map(function (t) {
            return {
                totalCount: t.totalCount,
                item: _.map(t.items, function (item) {
                    return ({
                        variableName: item.variableName ? item.variableName : '-',
                        dataSourceName: item.dataSourceName ? item.dataSourceName : '-',
                        monitoringPointName: item.refVariableName ? item.refVariableName : '-',
                        groupName: item.groupName ? item.groupName : '-',
                        dataType: item.dataTypeStr ? item.dataTypeStr : '-',
                        address: item.refVariableAddress ? item.refVariableAddress : '-'
                    });
                })
            };
        }));
    };
    RemoteVariableService.prototype.getVariableName = function (dataSourceCode, variableName, groupName) {
        return this.variableService.getConfigureVariableName(this.projectInfo.id, dataSourceCode, variableName, groupName).pipe(map(function (value) {
            if (!value || typeof value === 'object') {
                return undefined;
            }
            return {
                name: value,
                variableVersion: VariableVersion.variableVersion
            };
        }));
    };
    RemoteVariableService = __decorate([
        Injectable(),
        __param(1, Inject(CONFIGURE_PROJECT_INFO))
    ], RemoteVariableService);
    return RemoteVariableService;
}());
export { RemoteVariableService };
